import React from 'react';
import Backend from '../../../Layouts/Backend';
import { Form, Row, Col } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import validationSchema from './infoValidation';
import { Alert, Button, Input, Loading } from '../../../UI/Common';
import PasswordConfirmation from '../../../UI/PasswordConfirmation';
import MapEditor from './MapEditor';
import helper from '../../../../utils/helper';
import { cloneDeep } from 'lodash';

function CUMap({ t, submitting, ...props }) {
  const editorRef = React.useRef(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [reInit, setReInit] = React.useState(true);
  const isRequireConfirmation = helper.isRequireConfirmation();
  const formik = useFormik({
    // enableReinitialize: reInit,
    initialValues: {
      name: '',
      description: '',
    },
    // onSubmit: (values) => {
    //   if (isRequireConfirmation) {
    //     setOpenModal(true);
    //   } else {
    //     const shapes = editorRef.current.fetchShapes();
    //     const isEditorValid = editorRef.current.checkError();
    //     console.log(shapes, 'CUMap');

    //     // if (isEditorValid) {
    //     //   if (props.isEdit) {
    //     //     props.onEditMap({ ...values, ...shapes });
    //     //   } else {
    //     //     props.onCreateMap({ ...values, ...shapes });
    //     //   }
    //     // }
    //   }
    // },
    validationSchema,
  });
  const handleSubmit = () => {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      const shapes = editorRef.current.fetchShapes();
      const isEditorValid = editorRef.current.checkError();
      formik
        .validateForm()
        .then((resp) => {
          if (Object.keys(resp).length === 0) {
            if (isEditorValid) {
              if (props.isEdit) {
                props.onEditMap({ ...formik.values, ...shapes });
              } else {
                props.onCreateMap({ ...formik.values, ...shapes });
              }
            }
          } else {
            formik.submitForm();
          }
        })
        .catch((err) => console.log('err'));
    }
  };
  React.useEffect(() => {
    if (props.isEdit && props.mapInfo && props.mapInfo.name) {
      formik.setValues(props.mapInfo);
    }
  }, [props.isEdit, props.mapInfo]);
  if (props.isEdit && (!props.bg || !props.bg.image.src)) {
    return (
      <Backend>
        <div className="content-inner d-flex">
          <Loading />
        </div>
      </Backend>
    );
  }
  function getTitle() {
    if (props.isEdit) return `Edit Map: ${props.mapInfo.name}`;
  }
  return (
    <Backend title={getTitle()}>
      <div className="content-inner d-flex flex-column">
        <Form
          className="d-flex flex-column flex-1 mb-0"
          // onSubmit={formik.handleSubmit}
        >
          <PasswordConfirmation
            isOpen={openModal}
            onCancel={() => setOpenModal(false)}
            onConfirm={() => {
              setOpenModal(false);
              const shapes = editorRef.current.fetchShapes();
              if (props.isEdit) {
                props.onEditMap({ ...formik.values, ...shapes });
              } else {
                props.onCreateMap({ ...formik.values, ...shapes });
              }
            }}
          />
          <Row className="mb-15">
            <Col>
              <Input
                required
                inline
                readOnly={props.isEdit}
                id="name"
                label="Name"
                onChange={formik.handleChange('name')}
                value={formik.values.name}
                invalid={formik.touched.name}
                error={formik.errors.name}
              />
            </Col>
            {/* <Col>
              <Input
                inline
                id="description"
                label="Description"
                onChange={formik.handleChange('description')}
                value={formik.values.description}
                invalid={formik.touched.description}
                error={formik.errors.description}
              />
            </Col> */}
          </Row>
          <Row className="mb-15 flex-1">
            <Col>
              <MapEditor
                sensors={props.sensors}
                groups={props.groups}
                formik={formik}
                ref={editorRef}
                shapes={cloneDeep(props.shapes)}
                bg={props.bg}
                isEdit={props.isEdit}
                originalDimension={props.originalDimension}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12} lg={12} xs={12}>
              <Alert.Error text={props.errors} />
            </Col>
            <Col md={12} lg={12} xs={12}>
              <Button
                id="cu-map"
                classes="mr-5"
                loading={submitting}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
              >
                <i className="md-icon">done</i>
                {t(props.isEdit ? 'Save' : 'Create')}
              </Button>
              <Button
                id="cancel-cu-map"
                loading={submitting}
                onClick={props.onBack}
              >
                {t('Cancel')}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </Backend>
  );
}

export default withTranslation('app')(CUMap);
